import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Layout from 'Components/layouts';
import { notify } from 'utils';
import TextField from '@material-ui/core/TextField';
import { REQUIRED_ERROR } from 'utils/constants';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Paths } from 'Routes/routePaths'
import { useHistory, useParams } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';
import { ExperimentServices } from 'Services/ExperimentServices';
import commonStyles, { pageTitleStyles } from 'theme/commonStyles';

const experimentService = new ExperimentServices();

const useStyles = makeStyles((theme) => ({
    inputStyle: {
        borderColor: '#838383',
        borderRadius: '25px',
    },
    pageHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 16,
        flexWrap: 'wrap',
        margin: '0 0 24px'
    },
    heading: {
        ...pageTitleStyles
    },
    btn: {
        padding: '8px 16px',
        minHeight: 40,
        height: 40,
        fontSize: '13px',
        color: 'white',
        borderRadius: '5px',
        marginLeft: '15px',
    },
    cancelBtn: {
        padding: '8px 16px',
        minHeight: 40,
        height: 40,
        background: '#B7B7B7',
        fontSize: '13px',
        color: 'white',
        borderRadius: '5px',
        marginLeft: '15px',
        "&:hover": {
            background: "#454343"
        }
    },
    placeBtn: {
        display: 'flex',
        justifyContent: 'end',
        padding: '20px 0',
        marginTop: 20
    },
    btnPwd: {
        background: '#3D7DDD',
        color: 'white',
        borderRadius: '25px',
        padding: '18px',
        marginTop: '-3px',
        marginLeft: '-42px',
        "&:hover": {
            background: "#3D7DDD"
        }
    },
}));

const initFormState = { name: '', link: '', duration: null, description: '' };

const AddExperiment = () => {

    const classes = useStyles();
    const commonClasses = commonStyles();
    const history = useHistory();
    const { id } = useParams();

    const [loading, setLoading] = React.useState(false);
    const [formState, setFormState] = React.useState({ ...initFormState });
    const [update, setUpdate] = React.useState(false);

    React.useEffect(() => {
        if (id) {
            getExperimentDetails()
        }
    // The route id is fixed for this mounted create/edit screen.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function getExperimentDetails(){
        let data = await experimentService.getExperimentDetail(id)
        if (data && data.data[0]) {
            let userData = data.data[0]
            setUpdate(true);
            setFormState({...userData});
        }
    }

    const handleInputChange = (evt) => {
        const { name, value } = evt.target;
        setFormState({ ...formState, [name]: value });
    }

    const formValidationCheck = () => {
        if (!formState.name || !formState.link) {
            notify("error", REQUIRED_ERROR);
            return null;
        }
        return handleFormSubmit();
    }

    const handleFormSubmit = async () => {
        setLoading(true);
        const payload = {...formState};
        let uuid = (update) ? id : null;
        await experimentService.addExperiment(payload, uuid).then(
            data => {
                notify('success', data.message)
                setLoading(false);
                history.push(Paths.Experiments);
            },
            error => {
                setLoading(false)
                notify("error", error.response.data.message ? error.response.data.message : 'Something Went Wrong');
                console.log('error.response.status', error);
            }
        );
    }

    return (
        <Layout>
            <main>
                <div className={commonClasses.contentWrapper}>
                    <div className={classes.pageHeader}>
                        <Typography
                            variant="subtitle2"
                            className={classes.heading}
                            color="textPrimary">
                            {update ? "Update" : "Create" } Experiment
                        </Typography>
                    </div>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                size="small"
                                label="Name *"
                                name="name"
                                value={formState.name}
                                type="text"
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                size="small"
                                label="Link *"
                                name="link"
                                value={formState.link}
                                type="text"
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                size="small"
                                label="Est. Duration in hours"
                                name="duration"
                                value={formState.duration || ''}
                                type="number"
                                onChange={handleInputChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                size="small"
                                label="Description"
                                name="description"
                                value={formState.description}
                                multiline
                                rows={4}
                                onChange={handleInputChange}
                            />
                        </Grid>
                    </Grid>
                    <div className={classes.placeBtn}>
                        <Button onClick={() => history.push(Paths.Experiments)} variant="outlined" color="default" className={classes.cancelBtn}>
                            Cancel
                        </Button>
                        <Button color="primary" variant="contained" className={classes.btn}
                            onClick={formValidationCheck}>
                            {loading ? <CircularProgress size={15} color="secondary" /> : update ? "Update" : "Save"}
                        </Button>
                    </div>
                </div>
            </main>
        </Layout>
    );
}

export default AddExperiment;
